import * as React from "react";
type Props = {
  className?: string,
};
function SvgArrowRight({ className }: Props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="utility-arrow-right"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.3431 17.6569L10.9289 16.2426L14.171 13.0009L6 13L6 11L14.172 11.0009L10.9289 7.75736L12.3431 6.34315L16.5858 10.5858L18 12L12.3431 17.6569Z"
        fill="currentColor"
      />
    </svg>
  );
}
export default SvgArrowRight;
